import { render, staticRenderFns } from "./FormShape.vue?vue&type=template&id=1fcf9be1&scoped=true&"
import script from "./FormShape.vue?vue&type=script&lang=js&"
export * from "./FormShape.vue?vue&type=script&lang=js&"
import style0 from "./FormShape.vue?vue&type=style&index=0&id=1fcf9be1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcf9be1",
  null
  
)

export default component.exports